<template>
  <div>
    <!-- <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading> -->
    <router-view></router-view>
    <notifications position="bottom right" />
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  data() {
    return {
      isLoading: false
    };
  },
  created() {
    axios.interceptors.request.use(
      config => {
        this.isLoading = true;
        return config;
      },
      error => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        this.isLoading = false;
        return response;
      },
      error => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );
  },
  components: {
    Loading
  },
  watch: {
    $route: {
      handler(to, from) {
        const body = document.getElementsByTagName("body")[0];
        if (from.name) {
          body.classList.remove("page--" + from.name.toLowerCase());
        }
        if (to.name) {
          body.classList.add("page--" + to.name.toLowerCase());
        }
      }
    }
  }
};
</script>

<style>
/* @import url("https://fonts.googleapis.com/css?family=Spartan&display=swap");
@import url("https://fonts.googleapis.com/css?family=Playfair+Display&display=swap"); */

html {
  font-size: 62.5%; /* 1rem = 10px */
  scroll-behavior: smooth;
}
body {
  box-sizing: border-box;
  color: #303030;
  font-family: "Spartan", sans-serif !important;
  letter-spacing: 0 !important;
  -webkit-font-smoothing: inherit !important;
  text-size-adjust: inherit !important;
  background: #fff;
}
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
address,
big,
cite,
code,
em,
font,
img,
small,
strike,
sub,
sup,
li,
ol,
ul,
fieldset,
form,
label,
legend,
button,
table,
caption,
tr,
th,
td {
  border: none;
  font-size: inherit;
  line-height: inherit;
  margin: 0;
  padding: 0;
  text-align: inherit;
}

blockquote::before,
blockquote::after {
  content: "";
}

ul,
ul li {
  list-style: none;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.container {
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  padding: 0;
}
:focus {
  outline: none;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Spartan", sans-serif;
  color: #303030 !important;
  font-weight: 400;
  margin: 0;
  text-align: center;
}
h1 {
  font-family: "Playfair Display", serif;
  line-height: 32px;
  font-size: 30px !important;
}
h2 {
  font-size: 26px;
  font-weight: 500;
}
h3 {
  font-size: 16px !important;
  color: #303030 !important;
  font-weight: 500;
}
h4 {
  font-size: 14px;
  font-weight: 500;
}
h5 {
  font-size: 14px;
}
h6{
  font-size: 12px;
}
.btn.btn-dark,
.btn.btn-outline-primary {
  height: 45px;
  line-height: 40px;
  font-size: 12px;
  color: #fff;
  background: #303030;
  border: 1px solid #303030;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 600;
  border-radius: 3px !important;
  margin-top: 6px;
}
.btn.btn-dark:hover {
  background: transparent;
  color: #303030;
  text-decoration: none;
}
.btn.btn-outline-primary {
  background: transparent;
  color: #303030;
}
.btn.btn-outline-primary:hover {
  background: #303030;
  color: #fff;
  text-decoration:none;
}
.btn:focus {
  box-shadow: none;
}
.dropset{
  position: relative;
}
label.setuplabel{
    position: absolute;
    background: #fff;
    top: 10px;
    z-index: 1;
    padding: 0 3px;
    left: 30px;
    font-size: 12px;
    color: #777777;
}
#app .md-checkbox {
  margin: 0;
}
#app .md-checkbox.md-theme-default .md-checkbox-container {
  border-width: 1px;
  border-color: #d2d2d2;
}
#app .md-checkbox .md-checkbox-container:hover {
  border-color: #191919;
}
#app .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: #ececec;
}
#app .md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  border-color: #191919;
}
#app .md-checkbox.md-theme-default.md-checked .md-checkbox-container:after {
  border-color: #191919;
}
#app .md-checkbox .md-checkbox-container:after {
  top: 2px;
  left: 6.5px;
  width: 5px;
  height: 11px;
}
#app .md-field.md-has-password .md-toggle-password {
  display: none;
}
#app .md-radio{
  margin-top:0;
  margin-bottom: 0;
}
#app .md-radio .md-radio-container{
  border:1px solid #d2d2d2;
}
#app .md-radio.md-checked .md-radio-container,#app .md-radio .md-radio-container:hover{
  border:1px solid #303030;
}
#app .md-radio.md-checked .md-radio-container:after{
  background: #303030;
}
.sign_up .md-field.haserror {
    margin-bottom: 0px;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus,
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: none;
  border: 1px solid #303030;
  background: transparent;
  color: #303030;
}
.sign_up .md-field,.commonform .md-field{
  display: inherit;
}
span.error-msg{
  color: red !important;
  margin-top: 5px;
  display: inline-block;
}
.commonform .md-field.haserror .md-input,.commonform .md-field.haserror .md-textarea,.commonform .haserror .vs__dropdown-toggle{
    border: 1px solid red;
}
#app .md-field.md-has-textarea:not(.md-autogrow) label{
  top: 6px;
}
#app .md-field.md-has-textarea:not(.md-autogrow) .md-textarea{
  height: 140px;
}
#app .vs__clear {
  margin-right: 25px;
}
#app .vue-notification-group{
  z-index: 9999;
}
@media only screen and (max-width: 1440px) {
  .container {
    max-width: 1200px;
  }
  header .logosec {
    margin-right: 35px;
  }
  header .inner_header .navigation-top,
  header .inner_header .search-account {
    width: 80.7%;
  }
}
</style>